export type VersionKey = 'dev' | 'staging' | 'prod'
export const version: VersionKey = 'prod'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const isNotProd = version !== 'prod'

export const releaseDate = '2025-06-16 16:42:05'
